import { render, staticRenderFns } from "./AccountSend.vue?vue&type=template&id=5da5e03c&scoped=true&"
import script from "./AccountSend.vue?vue&type=script&lang=js&"
export * from "./AccountSend.vue?vue&type=script&lang=js&"
import style1 from "./AccountSend.vue?vue&type=style&index=1&id=5da5e03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5e03c",
  null
  
)

export default component.exports